var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcEyeOff40 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.821 3.821c.651-.65 1.706-.65 2.357 0l30 30a1.667 1.667 0 1 1-2.357 2.358l-30-30a1.667 1.667 0 0 1 0-2.358",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.915 10.939q-.568.361-1.096.742c-2.519 1.812-4.52 3.986-5.752 5.483a4.43 4.43 0 0 0 0 5.672c1.233 1.497 3.233 3.67 5.752 5.483 2.504 1.802 5.664 3.348 9.181 3.348s6.676-1.546 9.182-3.348l.065-.048-4.07-4.07a6.667 6.667 0 1 1-9.378-9.378zm14.69 9.975q.06-.449.061-.914a6.667 6.667 0 0 0-7.58-6.604L15.92 10.23c-.424-.424-.274-1.141.3-1.315A13 13 0 0 1 20 8.333c3.517 0 6.676 1.546 9.182 3.348 2.518 1.812 4.518 3.986 5.751 5.483a4.43 4.43 0 0 1 0 5.672 35 35 0 0 1-2.522 2.75.817.817 0 0 1-1.15-.015zm-8.423-3.708a3.333 3.333 0 1 0 4.612 4.612z",
  clipRule: "evenodd"
})));
export default SvgIcEyeOff40;